import { truncate } from "lodash";
import { Link } from "react-router-dom";
import { Typography } from "@circle-react-uikit/Typography";
import type { Post } from "../types/post";
import "../assets/styles/news-post.css";

interface NewsPostProps {
  post: Post;
}

export const NewsPost = ({ post }: NewsPostProps) => (
  <Link
    className="border-primary bg-primary hover:bg-secondary dark:border-tertiary hover:dark:bg-tertiary mb-2 block cursor-pointer rounded-lg border p-4 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]"
    to={`/news/${post.id}`}
  >
    {post.cover_image_url && (
      <div>
        <img
          loading="lazy"
          alt={post.name}
          className="mb-4 rounded"
          src={post.cover_image_url}
        />
      </div>
    )}
    <div className="text-dark mb-1">
      <div className="news-title pb-3">
        <Typography.LabelMd weight="semibold">{post.name}</Typography.LabelMd>
      </div>
      <div className="news-excerpt">
        <Typography.BodySm>
          {truncate(post.body_plain_text, { length: 200 })}
        </Typography.BodySm>
      </div>
    </div>
  </Link>
);
